import gql from 'graphql-tag';
import { organizationFieldsFragment } from '@graphql/admin/fragments';

export const updateOrganizationSettingsMutation = gql`
  mutation UpdateOrganizationSettings($input: OrganizationSettingsInput!) {
    updateOrganizationSettings(input: $input) {
      ...AdminOrganizationFields
    }
  }

  ${organizationFieldsFragment}
`;